import React from 'react';
import { BecomeAMemberForm } from 'components/layout/forms';
import { PageWrapper2 } from 'components/modules/Wrapper2';
// import { home } from 'assets/images';
function BecomeAMemberView() {
	return (
		<div className='bg-[#0E1022]'>
			<PageWrapper2>
				<div>
					<BecomeAMemberForm />
				</div>
			</PageWrapper2>
		</div>
	);
}

export default BecomeAMemberView;
